import React from "react";
import cx from "classnames";
import PropTypes from "prop-types";
import LayersIcon from "../../assets/img/layers.svg";

// One line of the stacked promotions list: name, discount chip (with the
// layers icon on nested rows) and the info popover. Depth metadata drives the
// indentation and tree-connector classes; `ancestorRailDepths` are the rail
// columns that must keep running through this row because an ancestor still
// has siblings rendered after this row's subtree.
const StackedPromotionRow = ({
  name,
  discountValue,
  popover,
  depth = 0,
  isLastSibling = false,
  ancestorRailDepths = [],
}) => (
  <div
    className={cx("stacked-promotions__row", {
      "stacked-promotions__row--child": depth > 0,
      [`stacked-promotions__row--depth-${depth}`]: depth > 0,
      "stacked-promotions__row--last-child": depth > 0 && isLastSibling,
    })}
  >
    {ancestorRailDepths.map((railDepth) => (
      <span
        key={railDepth}
        className={cx(
          "stacked-promotions__ancestor-rail",
          `stacked-promotions__ancestor-rail--at-${railDepth}`
        )}
      />
    ))}
    <span className="stacked-promotions__name">{name}</span>
    <span className="stacked-promotions__chip">
      {depth > 0 ? (
        <img
          src={LayersIcon}
          className="stacked-promotions__stack-icon"
          alt="stacked rate"
        />
      ) : null}
      {discountValue}
    </span>
    {popover}
  </div>
);

StackedPromotionRow.propTypes = {
  name: PropTypes.string,
  discountValue: PropTypes.string,
  popover: PropTypes.node,
  depth: PropTypes.number,
  isLastSibling: PropTypes.bool,
  ancestorRailDepths: PropTypes.arrayOf(PropTypes.number),
};

export default StackedPromotionRow;
